import { ButtonType } from '../types';

export const ButtonTypes = {
  Primary: 'primary' as ButtonType,
  Secondary: 'secondary' as ButtonType,
  Basic: 'basic' as ButtonType,
};
